import {State} from '../types/state'

export const googleMapPolicyWarningVisible = (state: State) =>
  !(state.consentPolicy.policy.analytics && state.consentPolicy.policy.essential)
